module.exports = __webpack_public_path__ + "static/media/135U1_Bedroom1.99a0e8cf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135U1_Bedroom1.jpg
// module id = 535
// module chunks = 0